import http from '../../http'
export default {
    //创建草稿
    draftAdd: (params, appid) => {
        return http.post("/wxmp/wx/"+appid+"/draft/add", params);
      },
    // 草稿箱列表
    draftList:(params, appid) => {
      return http.get("/wxmp/wx/"+appid+"/draft/batchget", params);
    },
    // 修改草稿
    draftEdit:(params, appid) => {
      return http.post("/wxmp/wx/"+appid+"/draft/update", params);
    },
    // 删除草稿
    draftDel:(params, appid) => {
      return http.post("/wxmp/wx/"+appid+"/draft/delete", params);
    },
    // 获取草稿详细
    draftget:(params, appid) => {
      return http.get("/wxmp/wx/"+appid+"/draft/get", params);
    },
    // 获取粉丝标签
    draftTag:(params, appid) => {
      return http.get("/wxmp/wx/"+appid+"/tags/get", params);
    },
    // 拉取用户
    pulluser:(appid) => {
      return http.post("/wxmp/wx/"+appid+"/user/sync");
    },
    // 拉取草稿
    pulldrafts:(appid) => {
      return http.post("/wxmp/wx/"+appid+"/draft/sync");
    },
    // 群发草稿
    draftSend:(params, appid) => {
      return http.post("/wxmp/wx/"+appid+"/message/mass/sendall", params);
    },
    //用户列表
    wxUserList:(params, appid)=> {
      return http.get("/wxmp/wx/"+appid+"/user/get", params);
    },
    //打标签
    tags:(params, appid)=> {
      return http.post("/wxmp/wx/"+appid+"/tags/members/batchtagging", params);
    },
    // 取消标签
    cancelTags:(params, appid)=> {
      return http.post("/wxmp/wx/"+appid+"/tags/members/batchuntagging", params);
    },
    //加黑名单
    blacklist:(params, appid)=> {
      return http.post("/wxmp/wx/"+appid+"/tags/members/batchblacklist", params);
    },
    // 移除黑名单
    moveBlacklist:(params, appid)=> {
      return http.post("/wxmp/wx/"+appid+"/tags/members/batchunblacklist", params);
    },
    //发表记录列表
   publishList:(params, appid)=>{
    return http.get("/wxmp/wx/"+appid+"/publish/batchget", params);
   },
   // 删除已发表列表
   publishDel:(params, appid)=>{
    return http.post("/wxmp/wx/"+appid+"/publish/delete?id="+ params);
   }
}